import { createFileRoute, Link } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { adminApi } from "@/api/admin";

export const Route = createFileRoute("/admin/")({
  component: AdminProjectsList,
});

function AdminProjectsList() {
  const [q, setQ] = useState("");
  const [filter, setFilter] = useState<"all" | "suspended" | "active">("all");
  const { data, isLoading } = useQuery({
    queryKey: ["admin-projects", q, filter],
    queryFn: () => adminApi.listProjects({
      q: q || undefined,
      suspended: filter === "all" ? undefined : filter === "suspended",
      limit: 200,
    }),
  });

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold">All projects</h1>
        <p className="mt-1 text-ink/65">Suspend, change plan, record payment, transfer ownership.</p>
      </div>

      <div className="flex gap-3">
        <input
          className="input flex-1"
          placeholder="Search by project name…"
          value={q}
          onChange={(e) => setQ(e.target.value)}
        />
        <select className="input w-44" value={filter} onChange={(e) => setFilter(e.target.value as typeof filter)}>
          <option value="all">All</option>
          <option value="active">Active</option>
          <option value="suspended">Suspended</option>
        </select>
      </div>

      <div className="card overflow-x-auto p-0">
        <table className="w-full text-sm">
          <thead className="bg-cream text-left text-xs uppercase tracking-wide text-ink/55">
            <tr>
              <th className="px-4 py-3">Project</th>
              <th className="px-4 py-3">Owner</th>
              <th className="px-4 py-3">Plan</th>
              <th className="px-4 py-3">Members</th>
              <th className="px-4 py-3">Paid until</th>
              <th className="px-4 py-3">Status</th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? <tr><td colSpan={6} className="px-4 py-6 text-ink/55">Loading…</td></tr>
            : data?.projects.length ? data.projects.map((p) => (
              <tr key={p.id} className="border-t border-ink/8 hover:bg-cream">
                <td className="px-4 py-3">
                  <Link to="/admin/projects/$pid" params={{ pid: p.id }} className="font-medium text-primary-600 hover:underline">
                    {p.name}
                  </Link>
                  <div className="text-xs text-ink/45">{p.id.slice(0, 8)}…</div>
                </td>
                <td className="px-4 py-3 text-ink/65">{p.owner_email ?? "—"}</td>
                <td className="px-4 py-3">{p.plan_id}</td>
                <td className="px-4 py-3 text-ink/55">{p.member_count}</td>
                <td className="px-4 py-3 text-ink/55">{p.paid_until ? new Date(p.paid_until).toLocaleDateString() : "—"}</td>
                <td className="px-4 py-3">
                  {p.suspended ? (
                    <span className="rounded bg-red-500/15 px-2 py-0.5 text-xs font-medium text-red-600">suspended</span>
                  ) : (
                    <span className="rounded bg-green-500/15 px-2 py-0.5 text-xs font-medium text-green-600">active</span>
                  )}
                </td>
              </tr>
            )) : <tr><td colSpan={6} className="px-4 py-6 text-ink/55">No projects.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
